export default from './tooltip';



// WEBPACK FOOTER //
// ./app/components/tooltip/index.js